import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectFarmField');

    return {
        FARM: t('farm'),
        FARM_IS_REQUIRED: t('farmIsRequired')
    };
};

export default useTranslation;
